/**
 * TicketsocketCookie.
 *
 * Helper class to manage the cookie read/update for ticket data
 *
 * I created this as a class/singleton to abstract away the logic of
 * reading, storing, and updating the cookie data. As a singleton, all
 * relevant subscribers to the cookie data can reference a single source
 * of truth.
 *
 * author: nick.arcuri@spartan.com
 *
 */
var TicketsocketCookie = /** @class */ (function () {
    /**
     * constructor.
     */
    function TicketsocketCookie() {
        var _a;
        var cookieData = JSON.parse((_a = decodeURIComponent(window.ORW.utilities.getCookie('tickets'))) !== null && _a !== void 0 ? _a : '[]');
        if (cookieData.length) {
            this.data = cookieData;
        }
        else {
            console.warn('NO TICKET COOKIE FOUND');
        }
    }
    /**
     * removeTicket.
     *
     * @param {number} index
     */
    TicketsocketCookie.prototype.removeTicket = function (index) {
        var _a;
        this.data.splice(index, 1);
        window.ORW.utilities.setCookie('tickets', JSON.stringify((_a = this.data) !== null && _a !== void 0 ? _a : []), null, '.spartan.com');
    };
    return TicketsocketCookie;
}());
// Export as singleton to ensure one true source of data
export default new TicketsocketCookie();
